export { default as Ecology } from './IconEcology'
export { default as Economy } from './IconEconomy'
export { default as Society } from './IconSociety'